module.exports = __webpack_public_path__ + "img/product_87.070f71f.webp";